var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 19.9681V23.5811C26.0023 24.2591 25.7187 24.9071 25.2177 25.3661C24.7167 25.8241 24.0454 26.0511 23.3691 25.9901C19.6557 25.5871 16.0887 24.3211 12.9545 22.2921C10.0397 20.4431 7.56683 17.9761 5.71417 15.0671C3.67514 11.9251 2.40563 8.34812 2.00985 4.62512C1.94872 3.95212 2.17417 3.28412 2.63107 2.78412C3.08798 2.28512 3.73425 2.00012 4.41159 2.00012H8.03175C9.24314 1.98812 10.2752 2.87412 10.4445 4.07112C10.5978 5.22712 10.8814 6.36312 11.2892 7.45512C11.6208 8.33512 11.4094 9.32812 10.7461 9.99612L9.21409 11.5261C10.9315 14.5411 13.4334 17.0371 16.4544 18.7521L17.9864 17.2221C18.6567 16.5611 19.6507 16.3491 20.5335 16.6801C21.6276 17.0881 22.7649 17.3711 23.9242 17.5231C25.1376 17.6941 26.0293 18.7451 25.9993 19.9681Z",
    stroke: "#1930FF",
    strokeWidth: 2.40864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6aa6c7d118dcb4899a6c93298839f77e.svg";
export { ForwardRef as ReactComponent };